module.exports = __webpack_public_path__ + "img/wreckball_thumb.279984d6.jpg";